import angular from 'angular';

angular.module('webTools').controller('PortalCtrl', ['$scope', '$window', 'Reports',
	function($scope, $window, Reports) {

	}
]);
